import { calculateSettingsTimeout, sleep } from "../utils/index.js";
import { delayedMethod, delayedObservable, getPulseDelayedInstance } from "./instance.js";
function createSettingsService(settingDefaults = {}, settingAttributes = {}) {
    const timeout = calculateSettingsTimeout();
    const getSettings = delayedMethod('get');
    return {
        get(name, tag, defaultValue) {
            const ctrl = new AbortController();
            return Promise.race([
                getSettings(name, tag, defaultValue ?? settingDefaults[name], settingAttributes).then((v) => {
                    ctrl.abort();
                    return v;
                }),
                sleep(timeout, ctrl.signal).then(() => defaultValue),
            ]);
        },
        observe: delayedObservable('observe'),
        segments: delayedMethod('segments'),
        experiments: delayedMethod('experiments'),
    };
}
function createTrackerService() {
    return {
        event: delayedMethod('event'),
        events: delayedMethod('events'),
        attribute: delayedMethod('attribute'),
        attributes: delayedMethod('attributes'),
        set: delayedMethod('set'),
        flush: delayedMethod('flush'),
        cmd: delayedMethod('cmd'),
    };
}
function createSharedService() {
    return {
        getStateString: delayedMethod('getStateString'),
    };
}
function createInternals(config) {
    return {
        pulseInit: [],
        ready: [],
        idu: globalThis.location?.href,
        c: config,
    };
}
function createPulseProxy(config) {
    async function pulseFn() {
        // eslint-disable-next-line prefer-rest-params
        const args = arguments;
        const instance = await getPulseDelayedInstance();
        if (typeof args[0] === 'function') {
            args[0](instance);
            return;
        }
        // eslint-disable-next-line prefer-spread
        instance.cmd.apply(instance, args);
    }
    return Object.assign(pulseFn, createSettingsService(config?.defaults, config?.attributes), createTrackerService(), createSharedService(), { θ: createInternals(config) });
}
export function createGlobalProxy(config) {
    if (typeof globalThis !== 'object') {
        throw new Error('Unsupported execution environment!');
    }
    if (!globalThis.pulse) {
        const proxy = createPulseProxy(config);
        globalThis.pulse = proxy;
    }
    else {
        if (globalThis.pulse.θ.c?.app &&
            config?.app &&
            globalThis.pulse.θ.c?.app !== config.app) {
            throw new Error('Pulse is already initialized with a different app id!');
        }
    }
    return globalThis.pulse;
}
export function createScopedProxy(config) {
    return createPulseProxy(config);
}
//# sourceMappingURL=proxy.js.map